import { default as dashboardJson } from "../../../utils/defaultData/dashboard.json";
import { default as inquiriesJson } from "../../../utils/defaultData/inquiries.json";
import { default as batchJson } from "../../../utils/defaultData/batchData.json";
import { default as modesJson } from "../../../utils/defaultData/modes.json";
import { default as dispositionsJson } from "../../../utils/defaultData/dispositions.json";
import { default as locationJson } from "../../../utils/defaultData/location.json";
import { default as branchesJson } from "../../../utils/defaultData/branches.json";
import { default as coursesJson } from "../../../utils/defaultData/courses.json";
import { default as chaptersJson } from "../../../utils/defaultData/chapters.json";
import { default as modulesJson } from "../../../utils/defaultData/modules.json";
import { default as expenseCategoriesJson } from "../../../utils/defaultData/expenseCategories.json";
import { default as accountsJson } from "../../../utils/defaultData/accounts.json";
import { default as holidaysJson } from "../../../utils/defaultData/holidays.json";
import { default as languageJson } from "../../../utils/defaultData/language.json";
import { default as communicationMethodsJson } from "../../../utils/defaultData/communicationMethods.json";
import { default as couponsJson } from "../../../utils/defaultData/coupons.json";
import { default as channelJson } from "../../../utils/defaultData/channel.json";
import { default as campaignGroupJson } from "../../../utils/defaultData/campaignGroup.json";
import { default as campaignJson } from "../../../utils/defaultData/campaign.json";
import { default as transactionJson } from "../../../utils/defaultData/transactions.json";
import { default as studentJson } from "../../../utils/defaultData/students.json";
import { default as expenseJson } from "../../../utils/defaultData/expenses.json";
import { default as trainerJson } from "../../../utils/defaultData/trainer.json";
import { default as pendingFollowUpJson } from "../../../utils/defaultData/pendingFollowup.json";
import { default as questionsJson } from "../../../utils/defaultData/Questions.json";
import { default as registrationLink } from "../../../utils/defaultData/RegistrationLink.json";
import { default as registrationRequest } from "../../../utils/defaultData/RegistrationRequest.json";
import { default as assets } from "../../../utils/defaultData/assets.json";
import { default as resource } from "../../../utils/defaultData/Resource.json";
import { default as goalCategories } from "../../../utils/defaultData/goalCategory.json";
import { default as goal } from "../../../utils/defaultData/goal.json"
import { default as questionCategory } from "../../../utils/defaultData/questionCategory.json"
import { default as questionTechnology } from "../../../utils/defaultData/questionTechnology.json"
import { default as testQuestion } from "../../../utils/defaultData/testQuestion.json"
import { default as testSeries } from "../../../utils/defaultData/testSeries.json"
import { default as testCheck } from "../../../utils/defaultData/testCheck.json"
import { default as testAssign } from "../../../utils/defaultData/testAssign.json"

export const mergeUserModules = [
  { ...dashboardJson },
  { ...pendingFollowUpJson },
  { ...inquiriesJson },
  { ...batchJson },
  { ...expenseJson },
  { ...modesJson },
  { ...dispositionsJson },
  { ...locationJson },
  { ...branchesJson },
  { ...coursesJson },
  { ...chaptersJson },
  { ...modulesJson },
  { ...expenseCategoriesJson },
  { ...accountsJson },
  { ...holidaysJson },
  { ...languageJson },
  { ...communicationMethodsJson },
  { ...couponsJson },
  { ...channelJson },
  { ...campaignGroupJson },
  { ...campaignJson },
  { ...trainerJson },
  { ...transactionJson },
  { ...studentJson },
  { ...resource },
  { ...assets },
  { ...questionsJson },
  { ...registrationLink },
  { ...registrationRequest },
  { ...goalCategories },
  { ...goal },
  { ...questionCategory },
  { ...questionTechnology },
  { ...testQuestion },
  { ...testSeries },
  { ...testCheck },
  { ...testAssign },

];
